import state from './Common/states'
import mutations from './Common/mutations'
import actions from './Common/actions'
import getters from './Common/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
